import { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { Collapse } from "react-bootstrap";
import TransactionListDesktop from "../TransactionsAndCategoryOverview/TransactionsOverview/TransactionListOverview";
import TransactionListMobile from "../../mobile/transactions/TransactionListMobile";

const cardStyleBase = {
    background: "white",
    margin: "10px",
    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
    borderRadius: "10px",
    minWidth: "350px"
};

export default function InsightItem({ item, transactionType, isMobile }) {
    const [isOpen, setIsOpen] = useState(false);

    let text;
    if (item.category.diffInPercentage === 0) {
        text = (
            <h5 style={{ margin: "20px" }}>
                קטגוריה חריגה שלא הופיעה לאחרונה- <b>{item.category.category}</b>
            </h5>
        );
    } else {
        const change = item.category.diffInPercentage > 0 ? "עליה" : "ירידה";
        text = (
            <h5 style={{ margin: "20px" }}>
                בקטגורית <b>{item.category.category}</b> היתה {change} של <b>{item.category.diffInPercentage}</b> אחוזים
            </h5>
        );
    }

    return (
        <div dir={"rtl"} style={cardStyleBase}>
            {text}
            <div style={{ margin: "10px" }}>
                <b style={{ margin: "10px" }}>להצגת הפעולות</b>
                {isOpen ? (
                    <FaChevronUp
                        style={{ width: "50px" }}
                        onClick={() => setIsOpen(!isOpen)}
                        aria-controls="example-collapse-text"
                        aria-expanded={item.open}
                    />
                ) : (
                    <FaChevronDown
                        style={{ width: "50px" }}
                        onClick={() => setIsOpen(!isOpen)}
                        aria-controls="example-collapse-text"
                        aria-expanded={item.open}
                    />
                )}
            </div>
            <Collapse in={isOpen}>
                <div>
                    {isMobile ? (
                        <div dir="ltr">
                        <TransactionListMobile transactionType={transactionType} transactions={item.transactions} />
                        </div>
                    ) : (
                        <TransactionListDesktop transactionType={transactionType} items={item.transactions} />
                    )}
                </div>
            </Collapse>
        </div>
    );
}
